<template>
  <div class="modal-box">
    <div id="chat_message_content" class="chat_message_content">
        <template v-if="chatMessages != null">
            <div
                v-for="(item, index) in chatMessages"
                :key="index"
                :class="item.isMine ? 'me' : 'other'"
                class="chat_message_item"
                @contextmenu.prevent.stop="showMenu(item, !showMenuOpen, index)"
                v-on:change="setViewHeight" >
                <template v-if="item.isMine">
                    <div class="me_message_item"> 
                        <div class="me_message_bg"> 
                            <!-- <div class="message_label">{{item.message}}</div> -->
                            <div class="message_label" v-html="renderedMarkdown(item)"></div>
                        </div>
                        <div class="bottom_operate_content">                            
                            <div @click="onClickCopy(item)"
                                class="message_copy" >
                                <img 
                                src="../../assets/img/user/currency/message_copy.png"
                                class="message_copy_icon"
                                />
                            </div>
                            <div @click="onClickDeleteMessage(item)"
                                class="message_delete" >
                                <img 
                                src="../../assets/img/user/currency/message_delete.png"
                                class="message_delete_icon"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="ai_message_item"> 
                        <div class="ai_message_bg"> 
                            <!-- <div class="message_label">{{item.message}}</div> -->
                            <div class="message_label" v-html="renderedMarkdown(item)"></div>
                        </div>
                        <div class="ai_mark">本回答由 AI 生成，内容仅供参考，请仔细甄别。</div>
                        <div class="bottom_operate_content">
                            <div @click="onClickMessageToMapBt(item)"
                                :class="item.mindId > 1 ? 'open_map' : 'message_to_map'" >                   
                                <span class="bt_label" 
                                :id="'tomap_label_' + item.id">{{item.mindId > 1 ? '打开思维导图' : (item.mindId == -2 ? '转化中。。。' : '转思维导图')}}</span>
                            </div>
                            <div @click="onClickCopy(item)"
                                class="message_copy" >
                                <img 
                                src="../../assets/img/user/currency/message_copy.png"
                                class="message_copy_icon"
                                />
                            </div>
                            <div @click="onClickDeleteMessage(item)"
                                class="message_delete" >
                                <img 
                                src="../../assets/img/user/currency/message_delete.png"
                                class="message_delete_icon"
                                />
                            </div>
                        </div>
                    </div>
                    
                </template>                
            </div>
        </template>
        <div v-show="chatMessages.length == 0"
            class="tips_content" >
            <div class="tips_item" @click="onClickTipsChat">
                <div class="tips_title_content">
                    <img src="../../assets/img/user/currency/ai_chat_tips_icon.png"
                        class="tips_title_icon" /> 
                    <div class="tips_title">AI对话</div>
                </div>
                <span class="tips_des">高效交流，AI驱动内容</span>
            </div>
            <div class="tips_item" @click="onClickTipsTextToMap">
                <div class="tips_title_content">
                    <img src="../../assets/img/user/currency/txt_to_map_tips_icon.png"
                        class="tips_title_icon" /> 
                    <div class="tips_title">文字转思维导图</div>
                </div>
                <span class="tips_des">高效整理让复杂到一目了然</span>
            </div>
            <div class="tips_item" @click="onClickWordBt">
                <div class="tips_title_content">
                    <img src="../../assets/img/user/currency/word_to_map_tips_icon.png"
                        class="tips_title_icon" /> 
                    <div class="tips_title">Word、Txt转思维导图</div>
                </div>
                <span class="tips_des">智能解析、自动生成</span>
            </div>
        </div>
        <div v-show="chatMessages.length == 0"
            class="hello_content" >
            <img 
                src="../../assets/img/user/currency/ai_hi.png"
                class="hello_icon"
            />                    
            <span class="hello_label">我是寻简AI助手, 让你思如泉涌，灵感源源不断～</span>
        </div>
    </div>
    <div id="chat_input_content" class="chat_input_content">
        <div class="guestbook em">
            <a-form-item>
                <a-textarea class="chat_input"
                v-model="inputText"
                :placeholder="inputPlaceholder +'...'"
                :rows="12"
                style="resize: none;text-indent:2px;"
                v-decorator="[
                    'send',
                    {
                    rules: [
                        {
                        required: true,
                        message: getString(Strings.Input_Voicemail_isNull),
                        },
                    ],
                    },
                ]"
                @input="formValidation('send')"
                />
            </a-form-item>
        </div>
        <div class="chat_operate">
            <div class="operate_bt">
                <div @click="onClickDeepseekBt()"
                    :class="deepseekBt ? 'deepseek_bt_selected' : 'deepseek_bt_normal'"
                    class="deepseek_bt" >
                    <img
                      src="../../assets/img/user/currency/deepseek_icon.svg"
                      class="icon iconfont1-slider"
                    />
                    <img
                      src="../../assets/img/user/currency/deepseek_active_icon.svg"
                      class="icon-active iconfont1-slider"
                    />
                    <span class="bt_label">Deepseek v3</span>
                </div>

                <!-- <div @click="onClickToMapBt()"
                    :class="textToMapBt ? 'tomap_bt_selected' : 'tomap_bt_normal'"
                    class="tomap_bt" >
                    <img
                      src="../../assets/img/user/currency/tomap_icon.png"
                      class="icon iconfont1-slider"
                    />
                    <img
                      src="../../assets/img/user/currency/tomap_active_icon.png"
                      class="icon-active iconfont1-slider"
                    />
                    
                    <span class="bt_label">查询直接转思维导图</span>
                </div> -->

                <div @click="onClickToMapBt()"
                    :class="textToMapBt ? 'tomap_bt_selected' : 'tomap_bt_normal'"
                    class="tomap_bt" >
                    <img
                      src="../../assets/img/user/currency/tomap_icon.png"
                      class="icon iconfont1-slider"
                    />
                    <img
                      src="../../assets/img/user/currency/tomap_active_icon.png"
                      class="icon-active iconfont1-slider"
                    />
                    
                    <span class="bt_label">文字内容转思维导图</span>
                </div>

                <div @click="onClickWordBt()"
                    class="word_bt" >
                    <img 
                      src="../../assets/img/user/currency/file_word_icon.svg"
                      class="word_bt_icon"
                    />                    
                    <span class="bt_label">Word、Txt 转思维导图</span>
                    <input
                        type="file"
                        accept=".docx,.txt"
                        @change="handleResourceFile"
                        class="fileInputResource"
                    />
                </div>

                <div @click="onClickSendBt()"
                    class="send_bt" >
                    <img v-show="!isLoading"
                      src="../../assets/img/user/currency/arrow_up.png"
                      class="send_bt_icon"
                    />
                    <img v-show="isLoading"
                      src="../../assets/img/user/currency/chat_stop.png"
                      class="send_bt_icon"
                    />
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import SpinningAnimation from "../spinningAnimation/SpinningAnimation";
import strings from '../../common/lang/strings';
import getString from '../../common/lang/language';
import HttpServerConfig from '../../common/HttpServerConfig';
import Strings from "../../utils/Strings";
import AiChatMessage from "../../viewmodel/mindelementdata/vm/ai/AiChatMessage";
import ChatWindowVM from "../../viewmodel/mindelementdata/vm/ChatWindowVM";
if ( typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0 ) {
  var {ipcRenderer} = window.require('electron')
}
import MarkdownIt from 'markdown-it'
import MindMe from '../../viewmodel/facade/MindMe';
import store from "../../core/store";
import Config from "../../core/core/calcule/Config";
import Util from "../../utils/Util";
import { mapMutations } from "vuex";
import FileRead from "../../core/core/dataformat/FileRead";

export default {
  components: {
    SpinningAnimation,
  },
  data() {
    return {
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      deepseekBt: true,
      textToMapBt: false,
      isLoading: false,
      inputText: "",
      inputPlaceholder: "输入你的想法",
      toMapValue: "转思维导图",
      chatMessages: [],
      spinning: false, //加载动画
      isElectron: false,
      strings:strings,
      sendLeaveNote: this.$form.createForm(this),
      Strings,
      CanBeSent:false,
      inputValidation:{
        name:false,
        email:false,
        send:false
      }
    };
  },
  created() {
    this.isElectron = this.$tools.isElectron()
    ChatWindowVM.deleagte = this
    ChatWindowVM.loadData()
  },
  mounted() {
    this.get_bodyWidth();
    this.setViewHeight();
    this.setInputFocus();
    let input = document.getElementsByClassName("chat_input")
    if (input != null && input.length > 0) {
        let that = this;
        input[0].addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                if (event.isComposing) {
                    // 正在输入法组合过程中，不处理
                    return;
                }
                if (event.shiftKey) {
                    // 同时按下了 Shift 键：允许默认换行行为（不阻止默认事件）
                    return; 
                } else {
                    // 未按下 Shift 键：阻止默认换行，触发发送逻辑
                    event.preventDefault(); // 阻止默认的换行行为
                    that.onClickSendBt(); // 调用发送函数
                }
            }
        });
    } 
    
  },
  methods: {
    ...mapMutations([
      "isShowShoppingModel",
      "showLoginModel",
    ]),
    //语言包
    getString(i){
      return getString(i)
    },
    get_bodyWidth() {
      //动态获取浏览器高度
      const that = this;
      window.addEventListener("resize", () => {
        that.fullWidth = document.documentElement.clientWidth;
        that.fullHeight = document.documentElement.clientHeight;
        that.setViewHeight();
      });

    },
    subscriptionNumber(val) {
      //当前的数量
      if (val == null) {
        return;
      }
      if (val < 1000) {
        return val;
      } else if (val < 10000) {
        return parseInt(val / 1000) + "." + parseInt((val % 1000) / 100) + "k";
      } else {
        return (
          parseInt(val / 10000) +
          "." +
          parseInt((val % 10000) / 1000) +
          parseInt(((val % 10000) % 1000) / 100) +
          "w"
        );
      }
    },
    setViewHeight() {
        let rootMargin = 15
        let rootPadding = 5
        let padding = 15
        let inputHeight = 100
        let inputContentHeight = 150
        let messageContent = document.getElementsByClassName("chat_message_content")
        let inputContent = document.getElementsByClassName("chat_input_content")
        let input = document.getElementsByClassName("chat_input")
            
        if (messageContent != null && messageContent.length > 0) {
            messageContent[0].style.height = (this.fullHeight - rootMargin * 2 - padding * 3 - rootPadding * 2 - inputContentHeight) + "px";
        }
        if (inputContent != null && inputContent.length > 0) {
            inputContent[0].style.height = (inputContentHeight) + "px";
            
        }  
        if (input != null && input.length > 0) {
            input[0].style.height = (inputHeight) + "px";
        }    
    },
    formValidation(options) {
    },

    setInputFocus() {
        let input = document.getElementsByClassName("chat_input")
        if (input != null && input.length > 0) {
            input[0].focus();
        } 
    },

    updateMessages(messages, isScrollToBottom = true) {
        this.chatMessages = messages
        if (isScrollToBottom) {
            this.chatScrollToBottom()
            setTimeout(() => {
                this.chatScrollToBottom()
            }, 100);
        }
    },

    chatScrollToBottom() {
        const messageContent = document.getElementById('chat_message_content');
        if (messageContent != null) {
            // 滚动到底部
            messageContent.scrollTop = messageContent.scrollHeight;
        }
    },

    setChatLoading(value) {
        // console.log("vue--> ", this.isLoading, value, (typeof value));
        // if (value) {
        //     this.isLoading = value
        // } else {
            
        // }
        this.isLoading = value
    },

    setInputPlaceholder() {
        if (this.textToMapBt) {
            this.inputPlaceholder = "输入你想要提炼、转化思维导图的文字内容";
        } else {
            this.inputPlaceholder = "输入你的想法";
        }
    },

    onClickTipsChat() {
        this.deepseekBt = true
        this.textToMapBt = false
        this.setInputPlaceholder();
        this.setInputFocus()
        this.showMessage("请在输入栏输入问题")
    },

    onClickTipsTextToMap() {
        this.deepseekBt = false
        this.textToMapBt = true
        this.setInputPlaceholder();
        this.setInputFocus()
        this.showMessage("请在输入栏输入内容")
    },

    onClickDeepseekBt() {
        this.deepseekBt = !this.deepseekBt
        this.setInputFocus()
        this.setInputPlaceholder();
    },

    onClickToMapBt() {
        this.textToMapBt = !this.textToMapBt
        this.setInputPlaceholder();
    },

    onClickSendBt() {        
        if (this.inputText == null || this.inputText.length == 0) {
            return
        }
        let todayTimes = MindMe.getTodayUseAiAddTimes();
        if (!MindMe.isLogin()) {
            this.showLoginModel(false);
            setTimeout(() => {
                this.showLoginModel(true);
            }, 100);
            return;
        } else if (MindMe.isUpgrade()) {
            var restrictingAccessThresholdValues = 10; //会员每天开始受限伐值
            let memberExpire = MindMe.getMemberExpire();
            if (memberExpire > 365) { //永久会员
                restrictingAccessThresholdValues = 20;
            }            
            if (todayTimes > restrictingAccessThresholdValues && (Util.getCurrentTime() - Config.lastUseAITime) < 60 * 1000 * 2) {
                this.showError("网络繁忙请稍后重试！");
                return
            }
        } else {
            let times = MindMe.getUseAiAddTimes();            
            if ((times > 6 && todayTimes >= 1) || todayTimes >= 4) {
                this.isShowShoppingModel(true)
                return;
            }
            if (times > 10) {
                this.isShowShoppingModel(true)
                return;
            }
        }
        if (this.textToMapBt) {
            this.messageToAiChatForMap()
        } else {
            this.sendAiMessage()
        }
    },

    showMessage(value) {
        this.$message.success(value);
    },

    showError(value) {
        this.$message.error(value);
    },

    onClickMessageToMapBt(message) {
        // console.log("message.mindId-> ", message.mindId);
        
        if (message.mindId == -2) {
            this.showMessage("转化中，请等待")
            return;
        }
        if (message.mindId > -1) {
            ChatWindowVM.openMindMap(message.mindServerId);
        } else {
            if (message.message.length < 40) {
                this.showMessage("内容太少，无法提取思维导图")
                return;
            }
            message.setMindId(-2);
            ChatWindowVM.sendChatMessageToAiForMap(message);
        }
    },

    sendAiMessage() {
        if (this.inputText == null || this.inputText.length == 0) {
            return
        }
        if (this.inputText.length > 1000) {
            this.showError("发送的交流消息不能超过1000文字");
        } else if (this.inputText.length > 120) {
            ChatWindowVM.addNewChatMessage(this.inputText);
            ChatWindowVM.sendMessage(this.inputText, "deepseek-v3.1", false);
            this.inputText = "";
        } else {
            ChatWindowVM.addNewChatMessage(this.inputText);
            ChatWindowVM.sendMessage(this.inputText, "deepseek-v3.1", false);
            this.inputText = "";
        }
    },

    messageToAiChatForMap() {
        if (this.inputText == null || this.inputText.length == 0) {
            this.showMessage("请输入内容")
            return
        }
        if (this.inputText.length < 40) {
            this.showMessage("内容太少，无法提取思维导图");
            return;
        }
        ChatWindowVM.sendMessageToAiForMap(this.inputText);
        this.inputText = "";
    },

    onClickWordBt() {
        // this.showMessage("即将开放，请等待！");
        let todayTimes = MindMe.getTodayUseAiAddTimes();
        if (!MindMe.isLogin()) {
            this.showLoginModel(false);
            setTimeout(() => {
                this.showLoginModel(true);
            }, 100);
            return;
        } else if (MindMe.isUpgrade()) {
            var restrictingAccessThresholdValues = 10; //会员每天开始受限伐值
            let memberExpire = MindMe.getMemberExpire();
            if (memberExpire > 365) { //永久会员
                restrictingAccessThresholdValues = 20;
            }            
            if (todayTimes > restrictingAccessThresholdValues && (Util.getCurrentTime() - Config.lastUseAITime) < 60 * 1000 * 2) {
                this.showError("网络繁忙请稍后重试！");
                return
            }
        } else {
            let times = MindMe.getUseAiAddTimes();            
            if ((times > 6 && todayTimes >= 1) || todayTimes >= 4) {
                this.isShowShoppingModel(true)
                return;
            }
            if (times > 10) {
                this.isShowShoppingModel(true)
                return;
            }
        }        
        this.$el.querySelector(".fileInputResource").click();
    },

    handleResourceFile(e) {
      let $target = e.$target || e.srcElement;
      if ($target == null || $target.files == null || 
            $target.files.length == 0) {
        return false;
      }
      let file = $target.files[0];      
      if (file.size > 1024 * 1024 * 20) {
        this.$message.error(getString(strings.Message_Tips_Share_Explain_Does_Not_Exist));
        return false;
      }    
      new FileRead(this).readFile(file);  
    },

    readedTextComplete(text) {
        if (text == null || text.length == 0) {
            this.showMessage("没有读取到内容")
            return
        }
        if (text.length < 30) {
            this.showMessage("内容太少，无法转思维导图");
            return;
        }
        this.showMessage("内容已加入消息列表，正在转化为思维导图，请等待...");
        ChatWindowVM.sendMessageToAiForMap(text);
    },

    readedTextError(error) {
        if (error) {
            this.showError(error)
        }
    },

    onClickCopy(message) {
        const copyText = async () => {
            try {
              await navigator.clipboard.writeText(message.message);
              this.$message.success(
                getString(strings.Message_Tips_Copy_Success)
              );
            } catch (err) {
              this.$copyText(message.message).then(
                (res) => {
                  this.$message.success(
                    getString(strings.Message_Tips_Copy_Success)
                  );
                },
                (err) => {
                  this.$message.error("Failed to copy ", err);
                }
              );
            }
          };
        copyText();
    },

    onClickDeleteMessage(item) {
        ChatWindowVM.deleteChatMessage(item.id);
    },

    renderedMarkdown(message) {
        if (message == null || message.message == null) {
            return "";
        }
        const md = new MarkdownIt({
            html: true,         // 允许HTML标签
            linkify: true,      // 自动转换链接
            typographer: true   // 美化排版
        })            
        return md.render(message.message.trim())
    },
  },
  watch: {},
  computed: {
    
  },
};
</script>

<style lang="less" scoped>

.background-color-1 .main-content-children {
  overflow-y: hidden;
}
.background-color-2 .main-content-children {
  overflow-y: hidden;
}
.modal-box {
    padding-left: 15px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 15px;
    background-color: #fff;
    border-radius: 15px;
    margin-left: 5px;
    margin-top: 15px;
    margin-right: 15px;

    .modal-box {
        position: fixed;
        top: 119px;
    }

    .chat_message_content {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 15px;
        background-color: #ffffff;
        overflow-y: auto;

        .chat_message_item {
            display: inline-flex;
            margin-top: 0px;
            margin-bottom: 15px;
            margin-left: 15px;
            margin-right: 15px;
        }
        .me {
            justify-content: flex-end;
        }
        .other {
            justify-content: flex-start;
        }
        .ai_mark {
            margin-left: 10px;
            margin-top: 5px;
            font-size: 14px;
            color: #888888;
        }
        .me_message_item {
            .message_label {
                font-size: 16px;
                line-height: 2.0;
                color: #fff;
                user-select: text;

                /* 深色主题变量 */
                // --text-color: #fff;
                // --heading-color: #ddd;
                // --code-bg: #2d2d2d;
            }
            // markdown样式
            .message_label /deep/ h1 {
                font-size: 2em;
                font-weight:800;
                margin: 0.67em 0;
            }
            .message_label code {
                background-color: #00023c;
                padding: 2px 4px;
                border-radius: 3px;
            }
            .message_label /deep/ pre {
                background-color: #00023c;
                padding: 10px;
                border-radius: 5px;
                overflow-x: auto;
            }
            .message_label /deep/ h1,
            .message_label /deep/ h2,
            .message_label /deep/ h3,
            .message_label /deep/ h4,
            .message_label /deep/ h5,
            .message_label /deep/ h6 {
                color: var(--heading-color, #ffffff);
            }
            .message_label /deep/ hr {
                color: #98c5ff;
                border: 0;
                height: 0;
                border-top: 1px dashed #98c5ff;
                margin: 2em 0;
            }
            .message_label /deep/ code {
                background-color: var(--code-bg, #00023c);
                color: inherit; /* 继承文字颜色，或者也可以定义单独的变量 */
            }

            .me_message_bg {
                background-color: #472fff;
                border-radius: 10px 10px 0px 10px;
                padding: 5px 10px 5px 10px;
            }

            .bottom_operate_content {
                display: flex;
                justify-content:flex-end;
                margin-left: 10px;
                margin-top: 15px;
                align-items:center;
            }
            
            .message_copy {
                margin-left: 15px;
                cursor: pointer;
            }
            .message_copy_icon {
                width: 20px;
                height: 20px;
            }
            .message_delete {
                margin-left: 15px;
                cursor: pointer;
            }
            .message_delete_icon {
                width: 20px;
                height: 20px;
            }
        }
        .message_label /deep/ p {
            margin-bottom: 0;
        }
        .message_label /deep/ h1 {
            font-size: 2em;
            font-weight:800;
            margin: 0.67em 0;
        }
        .ai_message_item {
            .message_label {
                font-size: 16px;
                line-height: 2.0;
                color: #333;
                user-select: text;
            }
            // markdown样式            
            .message_label code {
                background-color: #2f2f2f;
                padding: 2px 4px;
                border-radius: 3px;
            }
            .message_label /deep/ pre {
                background-color: #1d1d1d;
                padding: 10px;
                border-radius: 5px;
                overflow-x: auto;
            }
            .message_label /deep/ hr {
                color: #9d9d9d;
                border: 0;
                height: 0;
                border-top: 1px dashed #9d9d9d;
                margin: 2em 0;
            }
            .message_label /deep/ h1,
            .message_label /deep/ h2,
            .message_label /deep/ h3,
            .message_label /deep/ h4,
            .message_label /deep/ h5,
            .message_label /deep/ h6 {
                color: var(--heading-color, #000000);
            }

            .message_label /deep/ code {
                background-color: var(--code-bg, #1d1d1d);
                color: #fff; /* 继承文字颜色，或者也可以定义单独的变量 */
            }
            
            .ai_message_bg {
                background-color: #f5f5f5;
                border-radius: 10px 10px 10px 0px;
                padding: 5px 10px 5px 10px;
            }
            .bottom_operate_content {
                display: flex;
                margin-left: 10px;
                margin-top: 15px;
                align-items:center;
            }
            .message_to_map {
                display: block;
                cursor: pointer;
                padding: 4px 10px 4px 10px;
                border-radius: 5px;
                background-color: #d2e9ff;
                .bt_label {
                    font-size: 13px;
                    color: #1673ff;
                    margin-left: 0px;
                    margin-right: 0px;
                }
                .bt_label:hover {
                    color: #0467fb;
                }
            }            
            .open_map {
                display: block;
                cursor: pointer;
                padding: 4px 10px 4px 10px;
                border-radius: 5px;
                background-color: #fff2d2;
                .bt_label {
                    font-size: 13px;
                    color: #fd8c14;
                    margin-left: 0px;
                    margin-right: 0px;
                }
                .bt_label:hover {
                    color: #eb7b04;;
                }
            }
            .message_copy {
                margin-left: 15px;
                cursor: pointer;
            }
            .message_copy_icon {
                width: 20px;
                height: 20px;
            }
            .message_delete {
                margin-left: 15px;
                cursor: pointer;
            }
            .message_delete_icon {
                width: 20px;
                height: 20px;
            }
        }        
        
        .hello_content {
            display: flex;
            position: absolute;
            bottom: 170px;
            align-items: end;

            .hello_icon {
                width: 128px;
                height: 128px;
                margin-left: 50px;
            }
            .hello_label {
                font-size: 22px;
                color: #333;
                margin-bottom: 35px;
                margin-right: 30px;
                font-weight:700;
                letter-spacing: 2.4px;
            }
        }

        .tips_content {
            display: flex;
            position: absolute;
            top: 100px;
            gap: 20px;
            justify-content:center;
            width: 90%;

            .tips_item {
                width: 200px;
                height: 60px;
                padding: 10px 10px 10px 15px;
                border-radius: 10px;
                background-color: #ffffff;
                border: solid 1px #d1d1d1;
                cursor: pointer;
            }
            .tips_item:hover {
                background-color: #efefef;
                border: solid 1px #d1d1d1;
            }
            .tips_title_content {
                display: flex; 
                align-items: center;
                .tips_title_icon {
                    width: 20px;            
                    height: 20px;           
                }   
                .tips_title {
                    margin-left: 8px;
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                }            
            }
            
            .tips_des {
                font-size: 12px;
                color: #8e8e8e;
                margin-top: 10px;
            }
        }
    }

    .chat_input_content {
        margin-left: 15px;
        margin-top: 20px;
        margin-right: 15px;
        margin-bottom: 0px;
        background-color: #ffffff;
        border-radius: 20px;
        border: solid 1px #ccc;
        box-shadow: 0px 0px 3px 3px #00000015;
    }
    .chat_input {
        font-size: 16px;
        padding: 15px;
        border-radius: 20px;
        border: none;

        &::placeholder {
            color: #9a9a9a;
        }
    }
    .ant-input:focus {
        border: none;
        border-color: #fff;
        box-shadow: 0 0 0 0px rgba(24, 143, 255, 0); /* 修改焦点发光效果 */
    }

    /* 方法2：使用自定义类名（推荐） */
    .chat_input :deep(.ant-input) {
        border: none;
        border-color: #fff;
        box-shadow: 0 0 0 0px rgba(24, 143, 255, 0); /* 修改焦点发光效果 */

        /* 标准写法 */
        &::placeholder {
            color: #8c8c8c;
        }
    }

    .chat_input :deep(.ant-input:focus) {
       border: none;
        border-color: #fff;
        box-shadow: 0 0 0 0px rgba(24, 143, 255, 0); /* 修改焦点发光效果 */
    }

    .chat_input :deep(.ant-input:hover) {
        border: none;
        border-color: #fff;
        box-shadow: 0 0 0 0px rgba(24, 143, 255, 0); /* 修改焦点发光效果 */
    }

    .chat_operate {
        display: flex;
        height: 46px;
        margin-top: -30px;
        align-items: center;
    }
    .operate_bt {
        display: flex;
        align-items: center;
    }
    .deepseek_bt {
        display: flex;
        align-items: center;
        margin-left: 15px;
        height: 36px;
        border-radius: 8px;
        // box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.041);
        cursor: pointer;
    }
    .deepseek_bt_selected {
        background-color: #ecf2ff;
        border: solid 1px #d5dff5;
        .icon-active {
            display: block;
        }
        .icon {
            display: none;
        }
        .bt_label {
            color: #4E6EF3; 
        }
    }
    .deepseek_bt_normal {
        background-color: #f2f2f2;
        border: solid 1px #e4e4e4;
        .icon-active {
            display: none;
        }
        .icon {
            display: block;
        }
        .bt_label {
            color: #333333; 
        }
    }
    
    .tomap_bt {
        display: flex;
        align-items: center;
        margin-left: 15px;
        height: 36px;
        border-radius: 8px;
        // box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.041);
        cursor: pointer;
    }
    .tomap_bt_selected {
        background-color: #ecf2ff;
        border: solid 1px #d5dff5;
        .icon-active {
            display: block;
        }
        .icon {
            display: none;
        }
        .bt_label {
            color: #4E6EF3; 
        }
    }

    .tomap_bt_normal {
        background-color: #f2f2f2;
        border: solid 1px #e4e4e4;
        .icon-active {
            display: none;
        }
        .icon {
            display: block;
        }
        .bt_label {
            color: #333333; 
        }
    }

    .send_bt {
        position: absolute;
        right: 50px;
        width: 34px;
        height: 34px;
        border-radius: 17px;
        background: linear-gradient(to bottom, #3F6BF8, #8B6CFC);
        cursor: pointer;

        .send_bt_icon {
            width: 14px;
            height: 14px;
            margin-top: 10px;
            margin-left: 10px;
        }
    }
    .word_bt {
        display: flex;
        align-items: center;
        position: absolute;
        right: 100px;
        height: 36px;
        cursor: pointer;

        .word_bt_icon {
            width: 20px;
            height: 20px;
        }
    }
    .iconfont1-slider {
        width: 24px;
        height: 24px;
        margin-left: 10px;
    }
    .bt_label {
        font-size: 14px;    
        margin-left: 5px;  
        margin-right: 10px;  
        margin-bottom: 1px;
        color: #333; 
    }
    .bt_label:hover {
        color: #4E6EF3; 
    }

    .em {
        margin-bottom: 0px;

        input {
            border: none;
        }
        input:focus {
            border: none;
        }
    }
    .shuang .sright {
        float: right;
    }

    .shuang .sleft input {
        height: 52px;
        border: 0px solid #d9d9d9;
        opacity: 1;
        border-radius: 4px;
    }
    .guestbook span {
        z-index: 5;
        padding-left: 20px;
        padding-top: 5px;
        position: absolute;
    }
    .ant-input:placeholder-shown {
        z-index: 2;
    }
    .fileInputResource {
        display: none;
    }
}
</style>